export default "__VITE_ASSET__COmrxYDw__"